import { render, staticRenderFns } from "./HistoryChanges.vue?vue&type=template&id=cbb1619a&"
import script from "./HistoryChanges.vue?vue&type=script&lang=js&"
export * from "./HistoryChanges.vue?vue&type=script&lang=js&"
import style0 from "./HistoryChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports